import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type"]

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import { withDefaults, defineOptions } from "vue";

interface Props {
  modifires?: typeModifires;
  type?: "button" | "submit" | "reset";
  label?: string;
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'button-submit',
  props: {
    modifires: { type: [String, Array, Boolean] },
    type: { default: "button" },
    label: {}
  },
  emits: ["click"],
  setup(__props: any, { emit }) {

const props = __props;






const handleClick = (e: Event) => emit("click", e);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(_unref(mapModifires)('button-submit', _ctx.modifires)),
    type: _ctx.type,
    onClick: handleClick
  }, _toDisplayString(_ctx.label), 11, _hoisted_1))
}
}

})